<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5">
                <h4 class="text-center text-white">
                    บริษัท สมบูรณ์ แพ็คเกจจิ้ง (888) จำกัด
                </h4>
                <div class="card mt-3">
                    <div class="card-body p-5">
                        <!-- <h3 class="text-center mb-4">เข้าสู่ระบบ</h3> -->
                        <div class="text-center">
                            <img src="../assets/Login_logo.png" class="img-fluid" alt="Responsive image">
                        </div>
                        <br/>
                        <form @submit="loginSubmitHandler">
                            <div v-if="!isScan" style="height:120px;">
                                <div class="form-group">
                                    <input
                                            id="username"
                                            type="text"
                                            class="form-control"
                                            name="username"
                                            placeholder="ชื่อบัญชี"
                                            required
                                            autofocus
                                            v-model="loginForm.username"/>
                                </div>
                                <div class="form-group">
                                    <input
                                            id="password"
                                            type="password"
                                            class="form-control"
                                            name="password"
                                            required
                                            placeholder="รหัสผ่าน"
                                            v-model="loginForm.password"/>
                                </div>
                            </div>
                            <div v-else style="max-height:120px;">
                                <div class="text-center">
                                    <img src="../assets/fingerprint.png" class="img-fluid" style="max-height:60px;" alt="Responsive image">
                                </div>
                                <br/>
                                <div class="text-center">
                                    <span style="color: red">กรุณาสแกนนิ้วเพื่อเข้าสู่ระบบ</span>
                                </div>
                                <br/>
                            </div>

                            <div class="form-group text-center">
                                <template v-if="!isScan">
                                    <button type="submit" class="btn btn-primary">
                                        <icon name="sign-in-alt"></icon>
                                        เข้าสู่ระบบด้วย username
                                    </button>
                                </template>
                                <template v-else>
                                    <button type="button" class="btn btn-primary"
                                            @click="goToFingerPrint(false)">
                                        <icon name="sign-in-alt"></icon>
                                        เข้าสู่ระบบด้วย username
                                    </button>
                                </template>
                                &nbsp;&nbsp;&nbsp;
                                <button type="button" class="btn btn-warning"
                                        @click="goToFingerPrint(true)" :disabled="isScan">
                                    <icon name="fingerprint"></icon>
                                    สแกนนิ้ว
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

var address;
export default {
    name: "login",

    data() {
        return {
            isScan: false,
            loginForm: {
                username: null,
                password: null
            },
            response: null,
            timer : null,
            val : 0,
        };
    },

    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            }
        })
    },

    methods: {
        loginSubmitHandler(ev) {
            ev.preventDefault();
            this.$store
                .dispatch("Auth/login", this.loginForm)
                .catch(err=>{
                    console.log(err);
                    alert("Login ไม่สำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง");
                    return Promise.reject(err)
                })
                .then(data => (this.response = data))
                .then(() => this.$store.dispatch("Auth/setUser"))
                .then(() => this.$router.push("/"));
        },

        goToFingerPrint(bool){
            this.isScan = bool;
            address = address ? address : '192.168.1.53';
            if(this.isScan){
                console.log(address);
                this.start();
                /*this.$store
                    .dispatch("Auth/createFingerPrint", {'ip' : address})
                    .then(data => {
                        this.response = data
                        console.log(this.response);
                        if(this.response){
                            this.start();
                        }
                    })*/
            } else {
                this.stop();
            }
        },
        start() {
            this.timer = setInterval( () => {
                ++this.val;
                this.getToken();
            }, 1000);
        },
        getToken(){
            this.$store
                .dispatch("Auth/getToken", {'ip' : address})
                .catch(err=>{
                    return Promise.reject(err)
                })
                .then(() => this.stop())
                .then(() => this.$store.dispatch("Auth/setUser"))
                .then(() => this.$router.push("/"))
        },
        stop() {
            clearInterval(this.timer);
            this.timer = null
        }

}
};
/**
 * Get the user IP throught the webkitRTCPeerConnection
 * @param onNewIP {Function} listener function to expose the IP locally
 * @return undefined
 */
function getUserIP(onNewIP) { //  onNewIp - your listener function for new IPs
    console.log("address :",address);
    //compatibility for firefox and chrome
    var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    var pc = new myPeerConnection({
            iceServers: []
        }),
        noop = function () {
        },
        localIPs = {},
        ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
        key;

    function iterateIP(ip) {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
    }

    //create a bogus data channel
    pc.createDataChannel("");

    // create offer and set local description
    pc.createOffer().then(function (sdp) {
        sdp.sdp.split('\n').forEach(function (line) {
            if (line.indexOf('candidate') < 0) return;
            line.match(ipRegex).forEach(iterateIP);
        });

        pc.setLocalDescription(sdp, noop, noop);
    }).catch(function (reason) {
        // An error occurred, so handle the failure to connect
    });

    //listen for candidate events
    pc.onicecandidate = function (ice) {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
    };
}

getUserIP(function(ip){
    alert("Got IP! :" + ip);
});

</script>

<style>
    * {
        font-family: "Sarabun", Helvetica, Arial, sans-serif;
    }
</style>
<style scoped>
.card {
    border-radius: 20px;
}
</style>

<style lang="scss">
body {
    background-color: lighten(black, 10%);
}
</style>
